<template>
  <div class="card-info">
    <div>
      <card-header></card-header>
      <tabs :tabs="tabs" :active="activeTab" @setTab="setTab" />
      <info v-if="activeTab === 0 && id" :id="id" />
      <images v-if="activeTab === 1 && id" :id="id" />
    </div>
  </div>
</template>
<script>
import CardHeader from "./CardHeader";

import Info from "./News/Info";
import Images from "./News/Images";

import Tabs from "../Tabs";
import { errorNotify } from "../../plugins/functions";

export default {
  name: "draw",
  props: ["id"],
  components: {
    CardHeader,
    Tabs,
    Info,
    Images
  },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Информация",
        },
        {
          title: "Слайд",
        },
      
      ],
      activeTab: 1,
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
  },
  created() {},
};
</script>